import React from "react";
import styles from "./SendButton.module.css";

interface SendButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isStreaming?: boolean;
  onStop?: () => void;
}

const SendButton: React.FC<SendButtonProps> = ({
  onClick,
  disabled = false,
  isStreaming = false,
  onStop,
}) => {
  if (isStreaming) {
    return (
      <button
        className={`${styles.button} ${styles.streaming}`}
        onClick={onStop}
        aria-label="Stop generating"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 14 14"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2.5" y="2.5" width="9" height="9" rx="1.5" />
        </svg>
      </button>
    );
  }

  return (
    <button
      className={`${styles.button} ${!disabled ? styles.active : ""}`}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      aria-label="Send message"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8 13V3M3.5 7L8 2.5L12.5 7" />
      </svg>
    </button>
  );
};

export default SendButton;